interface PayoutItem {
  PayoutNo: string; // Unique ID for the payout (used in Link state)
  AddedOn: string; // Date string in "DD-MM-YYYY" format
  SelfBusiness: number | string; // Amount for self business
  SelfBusinessPV: number | string; // Point Value for self business
  TeamBusiness: number | string; // Amount for team business
  TeamBusinessPV: number | string; // Point Value for team business
  SelfIncome: number | string; // Commission from self business
  TeamIncome: number | string; // Commission from team business
  TotalIncome: number | string; // Sum of Self + Team Income
}

export const AssoPayoutListData = Array.from({ length: 50 }, (_, i) => {
  return {
    PayoutNo: "PAY-2023-002",
    AddedOn: "15-02-2023",
    SelfBusiness: 60 * i,
    SelfBusinessPV: 12 * i,
    TeamBusiness: 30 * i,
    TeamBusinessPV: 60 * i,
    SelfIncome: 600 * i,
    TeamIncome: 30 * i,
    TotalIncome: 36 * i,
  };
});
